export default __webpack_public_path__ + "static/media/Chronicle of the Ancestors.6d6fc16f.jpg";